import classnames from 'classnames';

export interface IInputContainerProps {
    children?: React.ReactNode;
    className?: string;
    isFormControl?: boolean;
    size?: 'small' | 'medium' | 'large' | 'auto';
}

// Inputcontainers handle sizing of input elements
// Use auto prop to size columns based on the natural width of their content.
// Default behaviour: inputcontainer takes up available space evenly

/**
 * @deprecated use ksyos/design-system components instead. Remove if no longer used.
 */
export function InputContainer(props: IInputContainerProps) {
    const className = {
        'col-md-2': props.size === 'small',
        'col-md-4': props.size === 'medium',
        'col-md-12': props.size === 'large',
        'col-md-auto': props.size === 'auto',
        col: !props.size,
        'form-control': props.isFormControl,
    };

    return <div className={classnames(className, props.className || '')}>{props.children}</div>;
}
